import * as React from 'react';
import { RouteComponentProps } from 'react-router';
import * as request from 'superagent';
import { toast } from 'react-toastify';

export interface Teacher {
	_id: string,
	firstname: string,
	lastname: string,
	school: string
}

export namespace PermissionEdit {
	export interface Props extends RouteComponentProps<void> {
		allowedUsers: string[];
		editAllowedUsers: (users: string[]) => void;
	}

	export interface State {
		teachers: Teacher[];
		allowedUsers: string[];
		selectedTeacher: string;
		search: string;
	}
}


export default class PermissionEdit extends React.Component<PermissionEdit.Props, PermissionEdit.State> {

	constructor(props: PermissionEdit.Props) {
		super(props);

		this.state = {
			teachers: [],
			selectedTeacher: null,
			allowedUsers: props.allowedUsers,
			search: ''
		}

		request
		.get('/user/all')
		.set('accept', 'json')
		.end((err, res) => {
			console.log(err, res);
			if(err){
				toast.error("Opettajien hakeminen epäonnistui");
			}else{
				this.setState({teachers: res.body});
			}
		});

		this.selectTeacher = this.selectTeacher.bind(this);
		this.addTeacher = this.addTeacher.bind(this);
		this.deleteTeacher = this.deleteTeacher.bind(this);
		this.saveAndClose = this.saveAndClose.bind(this);
		this.search = this.search.bind(this);
	}

	addTeacher() {
		const {allowedUsers, selectedTeacher} = this.state;
		const newAllowedUsers = allowedUsers.slice();
		newAllowedUsers.push(selectedTeacher);
		this.setState({allowedUsers: newAllowedUsers});
	}

	deleteTeacher(id) {
		const {allowedUsers} = this.state;
		const newAllowedUsers = allowedUsers.slice();
		newAllowedUsers.splice(allowedUsers.indexOf(id), 1);
		this.setState({allowedUsers: newAllowedUsers});	
	}

	saveAndClose() {
		const { editAllowedUsers } = this.props;
		const { allowedUsers } = this.state;

		editAllowedUsers(allowedUsers);
	}

	selectTeacher(id: string) {
		this.setState({selectedTeacher: id});
	}

	search(e: any) {
		this.setState({search: e.target.value});
	}

	render() {
		const { teachers, selectedTeacher, allowedUsers, search } = this.state;

		const teacherDOMS = teachers
			.filter((teacher) => allowedUsers.indexOf(teacher._id) === -1)
			.filter((teacher) => {
				if(search){
					const srch = search.toUpperCase();
					const fn = teacher.firstname.toUpperCase();
					const ln = teacher.lastname.toUpperCase();
					const schl = teacher.school.toUpperCase();
					if(fn.indexOf(srch) === 0 || ln.indexOf(srch) === 0 || schl.indexOf(srch) === 0){
						return true;
					}else{
						return false;
					}
				}
				return true;
			})
			.map((teacher) => {
				const string = teacher.firstname + " " + teacher.lastname + ", " + teacher.school;
				const selectedClass = teacher._id === selectedTeacher ? "am_blue" : ""
				return (
					<div key={teacher._id} className={selectedClass} onClick={()=>this.selectTeacher(teacher._id)}>{string}</div>
				);
			});

		const adminTeacherDOMS = teachers.filter((teacher) => allowedUsers.indexOf(teacher._id) !== -1)
			.map((teacher) => {
				const string = teacher.firstname + " " + teacher.lastname + ", " + teacher.school;
				return <div key={teacher._id}>{string}<img src="images/CrossButton.png" onClick={() => this.deleteTeacher(teacher._id)} className="am_smallicon"/></div>
			})

		return (
			<div>
				<h4>Valitse, keiden kanssa jaat ryhmän hallinnan.</h4>
				<p>Opettajat</p>
				<div className="row">
					<div className="col-6">
						<input value={search} onChange={this.search} className="form-control mb-1" />
					</div>
				</div>
				<div className="row">
					<div className="col-6">
						<div className="am_flex am_campaigns">
							{teacherDOMS}
						</div>
						<button onClick={this.addTeacher} className="btn am_green-button am_shadow col-12 mt-1">LISÄÄ HALLINNOIJAKSI</button>
					</div>
					<div className="col-6">
						<div className="am_flex am_campaigns">
							<div>
								{adminTeacherDOMS}
							</div>
						</div>
						<button onClick={this.saveAndClose} className="btn am_green-button am_shadow col-12 mt-1">TALLENNA JA SULJE</button>
					</div>
				</div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/src/containers/Groups/permissionedit.tsx